var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3585 113.493C88.5022 113.493 113.749 88.2461 113.749 57.1025C113.749 25.9588 88.5022 0.711914 57.3585 0.711914C26.2149 0.711914 0.967987 25.9588 0.967987 57.1025C0.967987 88.2461 26.2149 113.493 57.3585 113.493Z",
    fill: "url(#paint0_linear_0_3067)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4773 108.428L30.922 82.9023L41.7465 71.9883L56.4773 108.428Z",
    fill: "CURRENTCOLOR"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8984 22.6076C38.9364 23.5695 26.5983 32.3878 29.2223 47.4767C30.4284 54.4083 38.0794 61.879 44.3863 69.4679C53.3563 80.2618 55.0553 83.1339 56.6163 87.0665C60.4423 96.7032 57.0744 106.579 56.5673 108.577C56.5673 108.577 64.6463 102.286 66.1843 93.8312C67.4663 86.7794 67.1683 84.9572 66.6354 81.7579C65.3533 74.0656 59.8303 67.6095 53.3613 60.4933C46.9504 53.4406 46.3733 53.006 41.6574 46.7609C38.8993 43.1085 37.3053 39.545 37.2143 35.0119C37.0803 28.3331 40.7474 21.7579 39.8984 22.6076H39.8984Z",
    fill: "CURRENTCOLOR"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1148 16.1435C46.1148 16.1435 46.4968 16.6514 47.2108 16.9043C48.1538 17.2392 49.6008 17.3271 50.7668 16.1894C51.8198 15.1611 51.7568 13.6709 51.4158 12.7441C51.1408 11.9971 50.6548 11.6045 50.6548 11.6045L51.3038 10.9326C51.3038 10.9326 51.5608 11.3223 52.1308 11.581C53.0978 12.0225 54.7608 12.2441 56.1118 10.6875C57.0948 9.55371 56.8718 8.19531 56.4698 7.33203C56.2128 6.78125 55.8688 6.37109 55.8658 6.34766C55.8588 6.28907 56.6038 5.56543 56.6038 5.56543L82.4248 31.5566L78.8118 35.042C78.8118 35.042 75.6218 31.0459 72.1328 30.8672C70.1148 30.7637 68.9478 30.7637 66.8608 31.2422C64.9858 31.6699 63.9858 32.1797 61.7238 30.9756C58.8788 29.4609 58.9378 26.3887 59.0118 24.7686C59.0718 23.4717 58.4598 22.7412 57.5808 22.7119C56.8048 22.6846 56.0318 22.9756 55.8658 24.2168C55.5268 26.7588 55.8408 28.501 57.7488 31.543C59.5838 34.4668 66.7298 41.5156 69.1058 44.2559C71.6558 47.1973 73.7578 48.8193 77.7828 54.4541C80.5258 58.2939 84.2238 63.7578 84.2238 70.4668C84.2238 75.5371 82.7338 78.623 80.8098 82.4697C78.8868 86.3174 72.8928 92.3252 72.9968 92.0869C73.1018 91.8477 75.2338 85.2432 74.8458 77.1768C74.3638 67.1406 65.5428 59.2852 60.6518 53.4414C56.6948 48.7109 53.1968 45.1289 49.2018 39.6045C42.3428 30.1221 46.1148 16.1436 46.1148 16.1436V16.1435Z",
    fill: "CURRENTCOLOR"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_3067",
    x1: 57.3612,
    y1: 0.638937,
    x2: 57.3612,
    y2: 113.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78C4BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4F9994"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#363681"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.550b11475d9130afa18ce5b91800ac7d.svg";
export { ForwardRef as ReactComponent };